/*
 *
 * UrlClickToPayField
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 03-Jun-2026
 */

import UrlClickToPayField from './UrlClickToPayField'

export default UrlClickToPayField
